var OpenDesignCodeLengthEnum;
(function (OpenDesignCodeLengthEnum) {
    OpenDesignCodeLengthEnum[OpenDesignCodeLengthEnum["min"] = 5] = "min";
    OpenDesignCodeLengthEnum[OpenDesignCodeLengthEnum["max"] = 6] = "max";
})(OpenDesignCodeLengthEnum || (OpenDesignCodeLengthEnum = {}));
export default OpenDesignCodeLengthEnum;
//# sourceMappingURL=OpenDesignCodeLengthEnum.js.map